import React from "react";
import { Card } from "../../../shared";
import ChartWidget from "../widgets/ChartWidget";
import KpiWidget from "../widgets/KpiWidget";
import TableWidget from "../widgets/TableWidget";

const UnknownWidget = ({ widget }) => (
  <Card className="h-full rounded-lg">
    <div className="text-sm font-semibold text-gray-700">{widget?.title}</div>
    <div className="mt-2 text-sm text-gray-500">
      This dashboard widget type is not supported yet.
    </div>
  </Card>
);

const ErrorWidget = ({ widget }) => (
  <Card className="h-full rounded-lg border-red-200">
    <div className="text-sm font-semibold text-red-600">{widget?.title}</div>
    <div className="mt-2 text-sm text-gray-500">
      {widget?.message || "Unable to load this dashboard widget."}
    </div>
  </Card>
);

const WidgetRegistry = ({ widget, loading }) => {
  if (widget?.status === "error") return <ErrorWidget widget={widget} />;

  switch (widget?.type) {
    case "kpi":
      return <KpiWidget widget={widget} loading={loading} />;
    case "chart":
      return <ChartWidget widget={widget} loading={loading} />;
    case "table":
    case "list":
      return <TableWidget widget={widget} loading={loading} />;
    default:
      return <UnknownWidget widget={widget} />;
  }
};

export default WidgetRegistry;
